import styled from 'styled-components';

const ComponentPadding = styled.div`
  background: ${({ theme }) => theme.colors.background.light};
  flex: 1;
  padding: 2rem 0;
`;

export default ComponentPadding;
